import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=d3badc60"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"
import style0 from "./CreateCompany.vue?vue&type=style&index=0&id=d3badc60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports